import HttpService from './http.service.js'

class AuthService {
  async login(payload) {
    const loginEndpoint = 'login'
    return HttpService.post(loginEndpoint, payload)
  }

  async register(credentials) {
    const registerEndpoint = 'register'
    return HttpService.post(registerEndpoint, credentials)
  }

  async logout() {
    const logoutEndpoint = 'logout'
    return HttpService.post(logoutEndpoint)
  }

  async forgotPassword(payload) {
    const forgotPassword = 'password-forgot'
    return HttpService.post(forgotPassword, payload)
  }

  async resetPassword(credentials) {
    const resetPassword = 'password-reset'
    return HttpService.post(resetPassword, credentials)
  }

  async createAccount(credentials) {
    const createAccount = 'create-account'
    return HttpService.post(createAccount, credentials)
  }

  async getCreatorToken() {
    const getCreatorTokenEndpoint = 'get_creator_token'
    return HttpService.get(getCreatorTokenEndpoint)
  }

  async changePassword(credentials) {
    const changePasswordEndpoint = 'password-change'
    return HttpService.post(changePasswordEndpoint, credentials)
  }
}

export default new AuthService()
